import Button, { ButtonProps } from "@components/button/button";
import { buttonTheme } from "@components/button/button-constants";
import { TopicflowIcon } from "@components/topicflow-icon/topicflow-icon";
import { TopicflowIconType } from "@components/topicflow-icon/topicflow-icon-helpers";
import { titleCase } from "@helpers/string";

// The "add one of these" affordance on the roles and competencies tables: an
// icon and a label, with no box of its own, so a page full of them stays
// quiet. Button won't take an icon and text together, so the icon is a child.
const AddButton = ({
  text,
  icon = "plus",
  ...props
}: Omit<ButtonProps, "icon" | "text" | "children" | "theme"> & {
  text: string;
  // Defaults to a plus; adding a person to a role gets its own.
  icon?: TopicflowIconType;
}) => (
  <Button theme={buttonTheme.text} {...props}>
    <TopicflowIcon type={icon} className="h-4 w-4 shrink-0" />
    {/* Children skip the title-casing Button gives its text prop, so these
        labels stay in step with every other button. */}
    {titleCase(text)}
  </Button>
);

export default AddButton;
